/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-16 10:52:49
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-09 12:57:49
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/Components/HomepageSEOSetting/index.tsx
 */
/**
 *  Seo Setting
 *  Author: Luke
 *  CreatedAt: 2021-03-04
 */
import React from 'react';

import css from './css.less';

import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import { Input, TextArea } from 'src/components/Antd';

import CountWordsWithFormItem from 'src/components/CountWords/CountWordsWithFormItem';
import { Field } from 'src/components/RcForm';
import SingleImageUploader from 'src/constrains/SingleImageUploader';
// import { useSubscription } from 'src/pages/SalesChannelContentEditor/SalesChannelEditorHomepageResponsive/hooks/useSubscription';
// import TermsAndConditions from 'src/components/Modules-revamp/TermsAndConditions';
// import { EPreviewSize } from 'src/types/common/SalesChannel';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const HomePageSEOSetting = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { isPrimary, titleKey, descriptionKey, faviconKey } = props;
  // const { handleOnTcReselect, tcsOptions, handleOnDelete, handleOnSort } =
  //   useSubscription();
  return (
    <div className={css.container}>
      {/* <TermsAndConditions
        onSort={handleOnSort}
        onDelete={handleOnDelete}
        onReselect={handleOnTcReselect}
        tcsOptions={tcsOptions}
        draggableId={'123123'}
        breakpoint={EPreviewSize.WIDE}
      /> */}
      <Section>
        <ItemWrapper
          title={getI18n('general.customer.title')}
          rightPart={
            <CountWordsWithFormItem maxCount={100} keyName={titleKey} />
          }>
          <Field name={titleKey}>
            <Input
              // value={title}
              // onChange={onTitleChange}
              size='large'
              placeholder={`${getI18n('general.customer.title')} (0/100)`}
              maxLength={100}
            />
          </Field>
        </ItemWrapper>
        <ItemWrapper
          rightPart={
            <CountWordsWithFormItem maxCount={500} keyName={descriptionKey} />
          }
          title={getI18n('salesChannelContent.index.homepageMetaDescription')}>
          <Field name={descriptionKey}>
            <TextArea
              maxLength={500}
              placeholder={`${getI18n(
                'salesChannelContent.index.homepageMetaDescription',
              )} (0/500)`}
            />
          </Field>
        </ItemWrapper>
        {isPrimary && (
          <ItemWrapper
            title={`${getI18n(
              'salesChannelContent.index.favicon',
            )} (196px * 196px)`}>
            <div className={css.favContainer}>
              <Field name={faviconKey}>
                <SingleImageUploader height={180} />
              </Field>
            </div>
          </ItemWrapper>
        )}
      </Section>
    </div>
  );
};
export default HomePageSEOSetting;
